export default __webpack_public_path__ + "static/media/logo-cafeteriaplan.e5828eeb.png";